"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./InputList.less");

var _underscore = _interopRequireDefault(require("underscore"));

var _InputListItem = _interopRequireDefault(require("./InputListItem"));

var _subtract = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/subtract"));

var _add = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/add-2"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputList, _Component);

  var _super = _createSuper(InputList);

  function InputList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputList);
    _this = _super.call(this, props);
    _this.state = {
      items: _this.props.inputListItems
    };
    _this.handleAdd = _this.handleAdd.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InputList, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!_underscore.default.isEqual(nextProps.inputListItems, this.props.inputListItems)) {
        this.setState({
          items: nextProps.inputListItems
        });
      }
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(item, index) {
      var items = this.state.items.slice();

      if (items.indexOf(item) > -1) {
        items.splice(index, 1);
        this.setState({
          items: items
        }, this.props.onRemove(items));
      }
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      var id = this.state.items.length;
      var items = this.state.items.slice();
      var length = items.length; //if last item is empty, can not add another one

      if (length > 0 && items[length - 1].description !== '') {
        var addedValue = '';
        var newItem = {
          id: id,
          description: addedValue
        };
        items.push(newItem);
      }

      this.setState({
        items: items
      }, this.props.onAdd(items));
    }
  }, {
    key: "handleChange",
    value: function handleChange(index, value) {
      var items = this.state.items.slice();
      items[index] = {
        id: index,
        description: value
      };
      this.setState({
        items: items
      }, this.props.onChange(index, value));
    }
  }, {
    key: "renderInputListItems",
    value: function renderInputListItems() {
      var _this2 = this;

      return this.state.items.map(function (item, index) {
        var props = {
          onChange: _this2.handleChange.bind(_this2),
          onAdd: _this2.handleAdd.bind(_this2),
          onRemove: _this2.handleRemove.bind(_this2),
          value: item.description,
          key: index,
          index: index,
          placeholder: _this2.props.placeholder,
          itemMaxLength: _this2.props.itemMaxLength,
          itemMinLength: _this2.props.itemMinLength,
          size: _this2.props.size
        };

        if (index !== _this2.state.items.length - 1) {
          props.icon = /*#__PURE__*/_react.default.createElement("a", {
            className: "ai-icon ai-icon-delete",
            href: "javascript:void(0)",
            onClick: function onClick() {
              _this2.handleRemove(item, index);
            }
          }, /*#__PURE__*/_react.default.createElement(_subtract.default, {
            noPad: true
          }));
        } else {
          props.icon = /*#__PURE__*/_react.default.createElement("a", {
            className: "ai-icon ai-icon-add",
            href: "javascript:void(0)",
            onClick: function onClick() {
              _this2.handleAdd();
            }
          }, /*#__PURE__*/_react.default.createElement(_add.default, {
            noPad: true
          }));
        }

        return /*#__PURE__*/_react.default.createElement(_InputListItem.default, (0, _extends2.default)({
          key: index
        }, props));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          size = _this$props.size,
          className = _this$props.className;
      var classNameProps = Object.assign({}, {
        'className': (0, _classnames.default)('primitive-input-list', (_classNames = {}, (0, _defineProperty2.default)(_classNames, className, className), (0, _defineProperty2.default)(_classNames, size, size), _classNames))
      });
      return /*#__PURE__*/_react.default.createElement("div", classNameProps, this.renderInputListItems());
    }
  }], [{
    key: "propTypes",
    value: // @TODO Add minLength and maxLength and might add more propTypes in the future
    function propTypes() {
      return {
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large']),
        inputListItems: _propTypes.default.array,
        placeholder: _propTypes.default.string,
        onChange: _propTypes.default.func,
        onRemove: _propTypes.default.func,
        onAdd: _propTypes.default.func,
        itemMinLength: _propTypes.default.string,
        itemMaxLength: _propTypes.default.string,
        className: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        size: '',
        inputListItems: [],
        placeholder: '',
        onChange: function onChange() {},
        onRemove: function onRemove() {},
        onAdd: function onAdd() {},
        itemMinLength: '',
        itemMaxLength: '',
        className: ''
      };
    }
  }]);
  return InputList;
}(_react.Component);

exports.default = InputList;